/* eslint-disable no-plusplus */

import moment from "moment";

/* eslint-disable no-bitwise */
export const femaleAvatarList = [
    "https://api.dicebear.com/7.x/micah/svg?seed=alex&mouth=smile",
    "https://api.dicebear.com/7.x/micah/svg?seed=sophie&mouth=smile",
    "https://api.dicebear.com/7.x/micah/svg?seed=emily&mouth=smile",
    "https://api.dicebear.com/7.x/micah/svg?seed=zara&mouth=smile"
]

export const maleAvatarList = [
    "https://api.dicebear.com/7.x/micah/svg?seed=mark&mouth=smile",
    "https://api.dicebear.com/7.x/micah/svg?seed=daniel&mouth=smile",
    "https://api.dicebear.com/7.x/micah/svg?seed=ryan&mouth=smile",
    "https://api.dicebear.com/7.x/micah/svg?seed=james&mouth=smile"
]

export function hashString(str) {
    let hash = 0;
    for (let i = 0; i < (str?.length ?? 0); i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
        hash |= 0;
    }
    return Math.abs(hash);
}

export function formatTimeOrDateOnly(dateString, fallback) {
    try {
        const cleanDate = dateString.replace(/\.\d{6}Z$/, 'Z');
        const parsed = moment.utc(cleanDate, "DD-MM-YYYY HH:mm:ssZ", true).toDate();

        if (Number.isNaN(parsed)) {
            throw new Error("Invalid date format");
        }

        const now = new Date();
        const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        const todayEnd = new Date(todayStart.getTime() + 24 * 60 * 60 * 1000 - 1);
        const local = new Date(parsed.getTime());

        if (local >= todayStart && local <= todayEnd) {
            return local.toLocaleTimeString('en-US', {
                hour: 'numeric',
                minute: 'numeric',
                hour12: true,
            });
        }

        return `${String(local.getDate()).padStart(2, '0')}/${String(local.getMonth() + 1).padStart(2, '0')}/${local.getFullYear()}`;
    } catch (error) {
        console.error("error in date time format", error);
        return fallback ?? ""
    }
}

export function fetchContactDetails(contact) {
    const lastThread = contact?.last_message;
    const lastMessage = lastThread ? lastThread?.body : "";
    const updateTime = lastThread ? formatTimeOrDateOnly(lastThread?.updated_at, lastThread?.updated_at_human) : null;
    const isLastMessageReceived = lastThread ? lastThread?.from_waid === contact?.to_waid : false;
    let leadName = `${contact?.lead?.first_name ?? ''} ${contact?.lead?.last_name ?? ''}`;
    // const salutation = contact?.lead?.salutation ?? "mrs";
    leadName = leadName?.trim();
    const unreadMessageCount = contact?.is_read ? 0 : (contact?.unread_count ?? 0);
    const isRegisteredNumber = contact?.lead?.id ?? false;
    const markedAsUnread = !contact?.is_read;
    const isMediaMessage = lastThread?.whatsapp_message_media?.whatsapp_media_mime_type;
    const phoneNumber = contact?.to_waid;
    const finalName = leadName || contact?.name || phoneNumber;
    const isCloseObject = {
        isClosed: contact?.is_closed,
        closedReason: contact?.metadata?.close_reason
    }
    let preview = "";
    if (lastThread) {
        const msgText = lastMessage || lastThread?.whatsapp_message_media?.whatsapp_media_caption || "";
        if (isLastMessageReceived) {
            preview = msgText;
        } else {
            preview = msgText ? `You: ${msgText}` : "";
        }
    }
    // const avatarIndex = hashString(finalName || phoneNumber);
    // const avatar = salutation?.toLowerCase()?.includes("mrs") ? femaleAvatarList[avatarIndex % femaleAvatarList.length] : maleAvatarList[avatarIndex % maleAvatarList.length];
    const avatar = `${finalName?.split(" ")?.[0] ?? ""} ${finalName?.split(" ")?.[1] ?? ""}`
    return {
        avatar, name: finalName, preview, time: updateTime, isMediaMessage, unreadMessageCount, isRegisteredNumber, markedAsUnread, phoneNumber, isCloseObject
    }
}

export const arePhoneNumsEqual = (num1, num2) => {
    const firstPhoneNum = `${num1 ?? ''}`;
    const secondPhoneNum = `${num2 ?? ''}`;
    return firstPhoneNum?.slice(-10) === secondPhoneNum?.slice(-10);
}

export function formatUKDate(dateString) {
    // Parse the input date string as UK time
    const parseDate = dateString.replace(/\.\d{6}Z$/, 'Z');
    const ukTime = moment(parseDate, "MM-DD-YYYY HH:mm:ssZ", true).toDate();

    // Check if the parsed date is valid
    if (Number.isNaN(ukTime)) {
        throw new Error('Invalid date format');
    }

    // Get the current local time and the time offset in minutes
    const now = new Date();

    // Adjust the UK time by the local offset to get the local time
    const localTime = new Date(ukTime.getTime());

    // Define the start and end of today in local time
    const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const todayEnd = new Date(todayStart.getTime() + 24 * 60 * 60 * 1000 - 1);

    // Define the format options for today and not today
    const optionsToday = {
        hour: 'numeric',
        minute: 'numeric',
        hour12: true
    };

    const optionsNotToday = {
        day: '2-digit',
        month: 'short',
        hour: 'numeric',
        minute: 'numeric',
        hour12: true
    };

    // Format and return the date string based on whether it is today or not
    if (localTime >= todayStart && localTime <= todayEnd) {
        return `Today, ${localTime.toLocaleString('en-US', optionsToday)}`;
    }
    return localTime.toLocaleString('en-US', optionsNotToday);

}

export function parsedDateTimeForWhatsapp(inputDate, fallbackDate, returnRawDateTime = false) {
    try {
        const date = inputDate?.split(' ')?.[0]?.split('-');
        const time = inputDate?.split(' ')?.[1];
        const newDateTimeString = `${date?.[1]}-${date?.[0]}-${date?.[2]} ${time}`;
        if (returnRawDateTime)
            return newDateTimeString;
        return formatUKDate(newDateTimeString);
    } catch (error) {
        console.error("Error in parsing date time");
        return fallbackDate;
    }
}

// HTML-entity encode every character that could break out of HTML text or
// attribute context. Used to defend against XSS — inbound WhatsApp message
// bodies are user-supplied and the rendered HTML output of parseWhatsappMarkup
// flows into a span via __html, so every literal byte from `text` MUST be
// entity-encoded before any markup transform fires.
const escapeHtml = (s) => String(s)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');

export const parseWhatsappMarkup = (text) => {
    if (!text) return '';

    // Split into tokens where placeholders like {{1}} are isolated. Both the
    // token interior AND the surrounding literal text are treated as
    // UNTRUSTED — patient-inbound and operator-typed messages can both flow
    // through this function, and either path can contain a `{{...}}` token
    // whose contents must not be allowed to inject HTML.
    const tokens = text.split(/({{.*?}})/g);

    return tokens
        .map((token) => {
            // Placeholder token (e.g. {{lead_first_name}} or {{1}}). Render
            // as the literal text `{{...}}` — never as HTML. Escape the
            // interior so a malicious body like `{{<img src=x onerror=...>}}`
            // can't inject a tag.
            if (token.startsWith("{{") && token.endsWith("}}")) {
                const body = token.slice(2, -2);
                return `{{${escapeHtml(body)}}}`;
            }

            // Step 1: entity-encode the entire literal segment FIRST. This
            // guarantees the input contains no live `<`, `>`, `&`, `"`, `'`
            // before any markup transform fires, so patient text like
            // `<script>alert(1)</script>` becomes inert
            // `&lt;script&gt;alert(1)&lt;/script&gt;` text.
            const escaped = escapeHtml(token);

            return escaped
                // Markdown-like formatting. Operates on already-escaped
                // text — the inserted `<b>`, `<i>`, etc. are the only raw
                // HTML this function emits. The `*`, `_`, `~`, backtick
                // markers themselves are ASCII and untouched by escapeHtml.
                .replace(/\*\*(.*?)\*\*/g, "<b>$1</b>")
                .replace(/\*(.*?)\*/g, "<b>$1</b>")
                .replace(/_(.*?)_/g, "<i>$1</i>")
                .replace(/~(.*?)~/g, "<s>$1</s>")
                .replace(/```(.*?)```/gs, "<code>$1</code>")
                .replace(/\n/g, "<br>")
                // Convert http(s) URLs to anchors. The `^https?://` prefix
                // is REQUIRED — `javascript:`, `data:`, etc. are rejected.
                // The matched URL is also re-escaped before being placed
                // inside `href="…"` to defend against any `&quot;` etc.
                // surviving the earlier pass (e.g. unicode normalisation).
                .replace(/(https?:\/\/[^\s<]+)/g, (_, url) => {
                    const safeUrl = escapeHtml(url);
                    return `<a href="${safeUrl}" target="_blank" rel="noopener noreferrer">${safeUrl}</a>`;
                })
                // Convert phone numbers (10+ digits) to tel: links. Phone
                // numbers contain only digits and a small set of ASCII
                // punctuation that is safe inside `href="tel:…"`, but we
                // still escape defensively.
                .replace(/(\+?\d[\d\s\-().]{9,}\d)/g, (_, num) => {
                    const safeNum = escapeHtml(num);
                    return `<a href="tel:${safeNum}">${safeNum}</a>`;
                });
        })
        .join('');
};

export const isWithin24Hours = inputDateTime => {
    try {
        const now = moment.utc();
        const parseDate = inputDateTime.replace(/\.\d{6}Z$/, 'Z');
        const targetTime = moment.utc(parseDate, "MM-DD-YYYY HH:mm:ssZ", true).add(24, 'hours');
        const difference = targetTime.diff(now);
        if (difference <= 0) {
            return false;
        }
        return true;
    } catch (error) {
        console.error("errror in timer", error);
        return false;
    }
}

// Server-aware service-window resolver. The backend now exposes
// ``service_window_open``, ``service_window_closes_at`` and ``last_inbound_at``
// on the thread serialiser. Prefer those when present; fall back to the
// legacy client-side computation off the last received bubble so the UI
// keeps working against an old API.
//
// Returns: { open: bool, closesAt: Date|null, msRemaining: number|null }
export const resolveServiceWindow = (thread, fallbackInboundIso) => {
    if (thread && typeof thread.service_window_open === 'boolean') {
        const closesAt = thread.service_window_closes_at
            ? new Date(thread.service_window_closes_at)
            : null;
        const msRemaining = closesAt
            ? Math.max(closesAt.getTime() - Date.now(), 0)
            : null;
        return {
            open: thread.service_window_open && (msRemaining === null || msRemaining > 0),
            closesAt,
            msRemaining,
        };
    }
    // Legacy fallback — derive from the last received bubble's timestamp.
    if (!fallbackInboundIso) {
        return { open: false, closesAt: null, msRemaining: null };
    }
    const open = isWithin24Hours(fallbackInboundIso);
    return { open, closesAt: null, msRemaining: null };
};

// Format the milliseconds-remaining value as "5h 12m" / "47m" / "30s" so
// the operator sees how much window they have left at a glance.
export const formatWindowRemaining = (msRemaining) => {
    if (!msRemaining || msRemaining <= 0) return null;
    const totalSec = Math.floor(msRemaining / 1000);
    const hours = Math.floor(totalSec / 3600);
    const minutes = Math.floor((totalSec % 3600) / 60);
    if (hours > 0) return `${hours}h ${minutes}m`;
    if (minutes > 0) return `${minutes}m`;
    return `${totalSec}s`;
};

// Fixed palette used for deterministic avatar colors
const AVATAR_COLORS = [
    // primary
    '#00A76F', '#007867', '#004B50',
    // secondary
    '#8E33FF', '#5119B7', '#27097A',
    // info
    '#00B8D9', '#006C9C', '#003768',
    // success
    '#22C55E', '#118D57', '#065E49',
    // warning
    '#FFAB00', '#B76E00', '#7A4100',
    // error
    '#FF5630', '#B71D18', '#7A0916',
    // greys (accent neutrals)
    '#637381', '#454F5B', '#212B36'
];

function stringToColor(string, phoneNumber) {
    const key = (string && String(string).trim()) || (phoneNumber && String(phoneNumber).trim()) || '';
    // Fallback to a primary color if we somehow get an empty key
    if (!key) return AVATAR_COLORS[0];

    const hash = hashString(key);
    const idx = Math.abs(hash) % AVATAR_COLORS.length;
    return AVATAR_COLORS[idx];
}

export function stringAvatar(name, phoneNumber, styleObject) {
    return {
        sx: {
            bgcolor: stringToColor(name, phoneNumber),
            ...(styleObject ?? {})
        },
        children: `${name?.split(' ')?.[0]?.[0]?.toUpperCase() ?? ""}${name?.split(' ')?.[1]?.[0]?.toUpperCase() || ""}`,
    };
}